export enum CUSTOM_IFRAME_EVENT {
    INTEGRATION_DIAGNOSTIC = "INTEGRATION_DIAGNOSTIC",
    PAYMENT_FLOW_COMPLETED = "PAYMENT_FLOW_COMPLETED",
    TOKENISATION_FLOW_COMPLETED = "TOKENISATION_FLOW_COMPLETED",
}
